import Vue from "vue";
import Vuex from "vuex";
const iconlib = require("../lib/iconlib.json");

Vue.use(Vuex);
// const iconlib = [
// 	{ value: "", text: "None" },
// 	{ value: "mdi-home", text: "Home" },
// 	{ value: "mdi-map-marker", text: "Pin" },
// 	{ value: "mdi-city", text: "City" },
// 	{ value: "mdi-account", text: "Person" },
// 	{ value: "mdi-account-group", text: "People" },
// 	{ value: "mdi-calendar-clock", text: "Event" },
// 	{ value: "mdi-clock", text: "Time" },
// 	{ value: "mdi-alarm", text: "Alarm" },
// 	{ value: "mdi-tree", text: "Tree" },
// 	{ value: "mdi-pine-tree", text: "Pine Tree" },
// 	{ value: "mdi-palm-tree", text: "Palm Tree" },
// 	{ value: "mdi-nature-people", text: "Nature" },
// 	{ value: "mdi-screw-round-top", text: "Screw" },
// 	{ value: "mdi-bolt", text: "Bolt" },
// 	{ value: "mdi-tools", text: "Tools" },
// 	{ value: "mdi-screwdriver", text: "Screwdriver" },
// 	{ value: "mdi-settings", text: "Settings" },
// 	{ value: "mdi-group", text: "Group" }
// ];

export default new Vuex.Store({
	state: {
		iconlib: iconlib,
		splashscreen: true,
		user: {
			_id: "guest",
			_rev: "",
			username: "guest",
			name: "Guest",
			preferences: {
				dark_mode: true
			},
			logged_in: false
		},
		assettypes: {},
		assets: {
			// assettype: {
			// 	id: "assettype",
			// 	type: "assettype",
			// 	name: "Asset Type"
			// },
			// guest: {
			// 	id: "guest",
			// 	type: "Person",
			// 	name: "Guest",
			// 	first_name: "Guest",
			// 	last_name: "",
			// 	password: "",
			// 	email: "guest@amos.com",
			// 	preferences: {},
			// 	status: "active"
			// },
			// group: {
			// 	id: "group",
			// 	type: "assettype",
			// 	name: "Group",
			// 	parent: "assettype",
			// 	icon: "mdi-group"
			// },
			// parts: {
			// 	id: "group",
			// 	type: "assettype",
			// 	name: "Parts",
			// 	parent: "group",
			// 	icon: "mdi-bolt"
			// },
			// location: {
			// 	id: "location",
			// 	type: "assettype",
			// 	name: "Location",
			// 	parent: "assettype",
			// 	icon: "mdi-map-marker"
			// },
			// building: {
			// 	id: "building",
			// 	type: "assettype",
			// 	name: "Building",
			// 	parent: "assettype",
			// 	icon: "mdi-city"
			// },
			// part: {
			// 	id: "part",
			// 	type: "assettype",
			// 	name: "Part",
			// 	parent: "assettype",
			// 	icon: "mdi-screw-round-top"
			// },
			// house: {
			// 	id: "house",
			// 	type: "assettype",
			// 	name: "House",
			// 	parent: "location",
			// 	icon: "mdi-home"
			// },
			// person: {
			// 	id: "person",
			// 	type: "assettype",
			// 	name: "Person",
			// 	parent: "assettype",
			// 	icon: "mdi-account"
			// },
			// a_parts: {
			// 	id: "a_parts",
			// 	type: "parts",
			// 	name: "Parts",
			// 	parent: ""
			// },
			// a_02: {
			// 	id: "a_02",
			// 	type: "group",
			// 	name: "People",
			// 	icon: "mdi-account-group",
			// 	parent: ""
			// },
			// a_03: {
			// 	id: "a_03",
			// 	type: "group",
			// 	name: "Places",
			// 	icon: "mdi-map-marker",
			// 	parent: ""
			// },
			// a_screws: {
			// 	id: "a_screws",
			// 	type: "group",
			// 	icon: "mdi-screw-round-top",
			// 	name: "Screws",
			// 	parent: "a_parts"
			// },
			// a_screw01: {
			// 	id: "a_screw01",
			// 	type: "group",
			// 	name: "M3 Screws",
			// 	icon: "mdi-screw-round-top",
			// 	qty: 50,
			// 	parent: "a_screws"
			// },
			// a_tools: {
			// 	id: "a_tools",
			// 	type: "group",
			// 	name: "Tools",
			// 	icon: "mdi-tools",
			// 	parent: "a_parts"
			// },
			// a_screwdriver: {
			// 	id: "a_screwdriver",
			// 	type: "tool",
			// 	name: "Philips Head Screwdriver",
			// 	icon: "mdi-screwdriver",
			// 	parent: "a_tools"
			// }
		},
		profilemenu: {
			visible: false
		},
		mainmenu: {
			visible: false
		},
		testmenu: {
			visible: false
		},
		activescreen: "dashboard",
		activeasset: false,
		activeassettype: false,

		datablur: false
	},
	mutations: {
		// logIn(state, user) {
		// 	console.warn("");
		// 	for (let key in user) {
		// 		state.user[key] = user[key];
		// 	}
		// 	state.user.logged_in = true;
		// 	// Put to pouch:
		// },

		// logOut(state) {
		// 	state.user.logged_in = false;

		// 	// @todo: CLEARR OUT DB when in production
		// },
		showProfileMenu(state) {
			state.profilemenu.visible = true;
		},
		hideProfileMenu(state) {
			state.profilemenu.visible = false;
		},
		showMainMenu(state) {
			state.mainmenu.visible = true;
		},
		hideMainMenu(state) {
			state.mainmenu.visible = false;
		},

		setScreen(state, options) {
			state.activescreen = options.screen;
		},

		setActiveAsset(state, options) {
			console.warn("Setting active asset:", options);
			state.activeasset = { _id: "", name: "Root" };
			if (options._id) {
				state.activeasset = state.assets[options._id];
			}
			if (options.asset) {
				state.activeasset = options.asset;
			}
		},

		setLocation(state, options) {
			if (options.assettype) {
				state.activeassettype = options.assettype;
			}
			if (options.asset) {
				state.activeasset = options.asset;
			}
		},
		deleteAssetOld(state, assetid) {
			//Recurse delete??

			delete state.assets[assetid];

			state.assets = JSON.parse(JSON.stringify(state.assets));
			console.warn("Deleted an asset:", assetid);
		},
		deleteAsset(state, options) {
			//Recurse delete??
			//console.warn("OPtions?", options);
			if (state.assets[options.assetid]) {
				options.pouch
					.remove(state.assets[options.assetid])
					.then(r => {
						console.warn("Deleted asset ", options.assetid);
						delete state.assets[options.assetid];
						state.assets = JSON.parse(JSON.stringify(state.assets));
						console.warn("Deleted an asset:", options.assetid);
					})
					.catch(err => console.error("[DBREMOVE] ", err));
			}
		},
		putAsset(state, options) {
			state.assets[options.asset._id] = options.asset;
			state.assets = JSON.parse(JSON.stringify(state.assets));

			console.warn("Updated an asset:", state.assets[options.asset._id]);
			options.pouch
				.put(options.asset)
				.then(r => {
					console.warn(
						"Asset revision: [" + state.assets[options.asset._id]._rev + "]",
						r.rev
					);
					state.assets[options.asset._id]._rev = r.rev;
					console.info(
						"[ASSET] " +
							state.assets[options.asset._id]._id +
							":" +
							state.assets[options.asset._id].name +
							" Updated ",
						r
					);
				})
				.catch(err => {
					console.error("[DBERROR] ", err);
				});
		},
		addAsset(state, options) {
			state.assets[options.asset._id] = options.asset;
			state.assets = JSON.parse(JSON.stringify(state.assets));
			console.warn("Added a new asset:", state.assets[options.asset._id]);
			options.pouch
				.put(options.asset)
				.then(r => {
					console.warn(
						"Asset revision: [" + state.assets[options.asset._id]._rev + "]",
						r.rev
					);
					state.assets[options.asset._id]._rev = r.rev;
					console.info(
						"[ASSET] " +
							state.assets[options.asset._id]._id +
							":" +
							state.assets[options.asset._id].name +
							" Updated ",
						r
					);
				})
				.catch(err => {
					console.error("[DBERROR] ", err);
				});
		},
		hideActiveAssetChildren(state, options) {
			console.info("Hiding Active Asset Children");
			for (let key in state.assets) {
				if (
					state.assets[key].type !== "assettype" &&
					state.assets[key].parent === state.activeasset._id
				) {
					state.assets[key].visible = false;
				}
			}
			state.assets = JSON.parse(JSON.stringify(state.assets));
			console.info("COMPLETE Hiding Active Asset Children");
		},
		showActiveAssetChildren(state, options) {
			console.info("Revealing Active Asset Children");
			for (let key in state.assets) {
				if (
					state.assets[key].type !== "assettype" &&
					state.assets[key].parent === state.activeasset._id
				) {
					state.assets[key].visible = true;
				}
			}

			state.assets = JSON.parse(JSON.stringify(state.assets));
			console.info("COMPLETE Revealing Active Asset Children");
		}
	},
	actions: {
		/**
		 * Installs a template for the user:
		 */
		installTemplate({ state }, data) {
			console.warn(
				"Installing new template - all existing data will be overwritten"
			);
			data = data || {};
			data.template = "demo";
			// data.template = "demo_home";
			state.assets = require("../lib/templates/" + data.template);
			console.warn(
				"Installed Template: " + data.template + " - assets:",
				state.assets
			);
			// Load assets into DB:
			console.warn("Pouch?", data, data.pouch);
			console.info("Storing assets in LOCAL DB:");
			data.pouch
				.bulkDocs(Object.values(state.assets))
				.then(result => {
					console.info("Alighty - results:", result);
				})
				.catch(err => {
					console.error("[DBERROR] ", err);
				});
		},

		logIn({ state }, data) {
			data._id = data._id || data.username;
			data._id = "guest";
			console.info(
				"LOGGING IN " + data.username,
				"[" + data._id + "]",
				data.pouch
			);
			// @todo!!!
			//data._id = "guest"; //data.username;
			return data.pouch
				.get(data._id)
				.then(doc => {
					console.warn("Fetched user:", doc);

					doc.username = data.username;

					state.user._id = doc._id;
					state.user._rev = doc._rev;
					state.user.name = doc.name;
					state.user.username = doc.username;
					state.user.preferences = doc.preferences;
					state.user.logged_in = true;
					doc.logged_in = true;
					console.warn("Storing user:", state.user._id, doc._id);
					localStorage.username = doc.username;
					data.pouch
						.put(doc)
						.then(r => {
							console.info("User " + doc.username + " was updated!", r);
							state.user._rev = r.rev; //UPDATE REVISION!
						})
						.catch(err => {
							console.error("[DBERROR] ", err);
						});
					// Fetch Assets:
					data.pouch
						.allDocs({ include_docs: true })
						.then(r => {
							//state.assets = r
							//console.warn("RETRIEVED ASSETS:", r);
							let tmp = {};
							r.rows.forEach(row => {
								tmp[row.doc._id] = row.doc;
							});
							console.warn("RETRIEVED ASSETS:", tmp);
							state.assets = tmp;
						})
						.catch(err => {
							console.error("[DBALLDOCSERROR] ", err);
						});
				})
				.catch(err => {
					console.error("[DBERROR] LOGIN ERROR: ", err);
				});
		},

		logOut({ state }, data) {
			state.user.logged_in = false;
			state.assets = [];
			// @todo: CLEARR OUT DB when in production
			// UPDATE DB:
			console.warn("Putting user updates - LOGGING OUT:", state.user);
			data.pouch.get(state.user._id).then(doc => {
				doc.logged_in = false;
				// Clear
				// localStorage.removeItem("username");
				data.pouch
					.put(doc)
					// data.pouch
					// 	.put({
					// 		_id: state.user._id,
					// 		_rev: state.user._rev,
					// 		logged_in: false
					// 	})
					.then(r => {
						console.warn("Updated USER!", r);
					})
					.catch(err => {
						console.error("[DBERROR] Logout fail - ", err);
					});
			});
		}
	},
	getters: {
		assettypes: state => {
			let items = {};
			for (let key in state.assets) {
				if (state.assets[key].type === "assettype" && key !== "assettype") {
					items[state.assets[key]._id] = state.assets[key];
				}
			}
			console.warn("Recalcing asset types...", items, state.assets);
			return items;
		},
		assettypesarray: state => {
			let items = [];
			for (let key in state.assets) {
				if (state.assets[key].type === "assettype" && key !== "assettype") {
					items.push(state.assets[key]);
				}
			}
			console.warn("Recalcing asset types...", items, state.assets);
			return items;
		},
		activescreen: state => state.activescreen,
		activeassets: state => {
			let items = {};
			for (let key in state.assets) {
				if (
					state.assets[key].type !== "assettype" &&
					state.assets[key].parent === state.activeasset._id
				) {
					items[state.assets[key]._id] = state.assets[key];
				}
			}
			return items;
		},
		hiddenactiveassets: state => {
			let items = {};
			for (let key in state.assets) {
				if (
					state.assets[key].type !== "assettype" &&
					state.assets[key].parent === state.activeasset._id
				) {
					items[state.assets[key]._id] = state.assets[key];
					items[state.assets[key]._id].visible = false;
				}
			}
			return items;
		},
		activeassetsarray: state => {
			let items = [];
			for (let key in state.assets) {
				if (
					state.assets[key].type !== "assettype" &&
					state.assets[key].parent === state.activeasset._id
				) {
					items.push(state.assets[key]);
				}
			}
			return items;
		},
		activeassetparentname: state => {
			if (state.activeasset && state.assets[state.activeasset.parent]) {
				return state.assets[state.activeasset.parent].name;
			} else {
				return "Root";
			}
		}
	}
});
